var getOperationOption = function(colorArr,labelArr,targetVal){
	// console.log("getOperationOption = ",colorArr,labelArr,targetVal)
	return {
    chart: {
      type: 'donut',
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '90%', //環形的寬窄
          labels: {
            show: true,
            value:{
              show: true,
              fontSize: '55px',
              fontWeight:900,
              offsetY:-15
            },
            total: {
              showAlways: true,
              show: true,
              label: '',
              fontSize: '12px',
              fontWeight: 600,
              color: '#373d3f',
              style:{'padding-top':'300px'},
              formatter: function (w) {
                return targetVal+'%' // value contnet with data
              }
            },
            
          },
        }
      }
    },
    tooltip : { enabled : false,theme: 'dark'}, //hover時的tooltip顯示資訊
    states: {
	    hover: { //關閉hover行為
        filter: {
        	type: 'none',
        }
	    },
		},
    legend:{show:false},//圖標
    dataLabels: {enabled: false},
    colors: colorArr,
    labels: labelArr
	}
}

var getTreatmentOption = function(colorArr,categoryArr){
	// console.log("getTreatmentOption = ",colorArr,categoryArr)
	return {
    colors: colorArr,
    chart: {
      type: 'line',
      stacked: false,
      toolbar:{show:false},
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [1, 1, 1, 4]
    },
    grid: {
      padding: {
        left: 20, // 圖表 padding
        right: 20 // 圖表 padding
      }
    },
    xaxis: {
      categories: categoryArr,
      tooltip: {
          enabled: false
        }
    },
    yaxis: [
      { 
        seriesName: '應有總顆數',
        show: false,
      },
      {
        seriesName: '應有總顆數',
        show: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#3a3a3a'
        },
        labels: {
          style: {
            colors: '#3a3a3a',
            fontSize:'14px'
          }
        },
        title: {
          text: "數量",
          style: {
            color: '#3a3a3a',
            fontSize:'18px',
          },
          rotate: 0,
          offsetX: -20,
        },
        tooltip: {
          enabled: true
        }
      },
      {
        seriesName: '應有總顆數',
        show: false
      },
      {
        seriesName: '達成率',
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#3a3a3a'
        },
        labels: {
          style: {
            colors: '#3a3a3a',
            fontSize:'14px'
          }
        },
        title: {
          text: "達成率",
          style: {
            color: '#3a3a3a',
            fontSize:'18px',
          },
          rotate: -90,
        },
      },
    ],
    legend: {
      horizontalAlign: 'left',
      position: 'left',
      floating: false,
      width: 150,
      labels: { // 圖標文字
        colors: ['#1f9dff','#ff9494','#67d2df','#ffa520'],
        useSeriesColors: false
      },
      markers: {
        width: 15,
        height: 15,
        strokeWidth: 0,
        strokeColor: '#FFF',
        radius: 10,
      },
      fontSize: '18px',
      itemMargin: {
        horizontal: 5,
        vertical: 10
    },
    }
  }
}

var getIncomePieOption = function(colorArr,labelArr,targetVal){
	return {
    chart: {
      type: 'donut',
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '85%', //環形的寬窄
          labels: {
            show: true,
            value:{
              show: true,
              fontSize: '55px',
              fontWeight:900,
              offsetY:-5
            },
            total: {
              showAlways: true,
              show: true,
              label: '',
              fontSize: '12px',
              fontWeight: 600,
              color: '#373d3f',
              style:{'padding-top':'300px'},
              formatter: function (w) {
                return targetVal +'%'// value contnet with data
              }
            },
            
          },
        }
      }
    },
    legend:{show:false},//圖標
    dataLabels: {enabled: false},
    colors: colorArr,
    labels: labelArr
  }
}

var getIncomeDeptOption = function(categoryArr){
	return {
    chart: {
      type: 'bar',
      height: 350,
      toolbar:{show:false}
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      }
    },
    colors: [
      // 設定不同數值對應不同的 bar color
      function({ value, seriesIndex, w }){
        let ICOME_UNIT=10000
        if (value < 80*ICOME_UNIT) {
          return '#eeeeee'
        }else if(value<100*ICOME_UNIT){
          return '#dcdcdc'
        }else if(value<150*ICOME_UNIT){
          return '#8ed8e2'
        }else if(value<200*ICOME_UNIT){
          return '#7fd3dd'
        }else if(value<220*ICOME_UNIT){
          return '#5dc8d5'
        }else{
          return '#35baca'
        }
      }
    ],
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      style: {
        fontSize: '16px',
        colors: [
          // 設定不同數值對應不同的 bar text color
          function(elem){
            let value = elem.series[0][elem.dataPointIndex]
            console.log("bar point value=",value)
            return (value<1000000)?'#787878':'#FFF'
          }
        ]
      }
    },
    
    xaxis:{
      categories: categoryArr,
      
    },
    yaxis:{
      labels:{
        style: {
          fontSize: '15px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 900,
          cssClass: 'apexcharts-xaxis-label',
        },
      }
    }
  }
}

var getIncomeDoctorOption = function(categoryArr){
	return {
    chart: {
      type: 'bar',
      height: 350,
      toolbar:{show:false}
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      }
    },
    colors: [
      function({ value, seriesIndex, w }){
        let ICOME_UNIT=10000
        if (value < 20*ICOME_UNIT) {
          return '#eeeeee'
        }else if(value<30*ICOME_UNIT){
          return '#e5e5e5'
        }else if(value<50*ICOME_UNIT){
          return '#dcdcdc'
        }else if(value<100*ICOME_UNIT){
          return '#ffc4c2'
        }else if(value<150*ICOME_UNIT){
          return '#ffa9a9'
        // }else if(value<160*ICOME_UNIT){
        //   return '#ff9494'
        }else{
          return '#ff9494'
        }
      }
    ],
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      style: {
        fontSize: '16px',
        colors: [
          function(elem){
            let value = elem.series[0][elem.dataPointIndex]
            console.log("bar point value=",value)
            return (value<600000)?'#787878':'#FFF'
          }
        ]
      }
    },
    
    xaxis:{
      categories: categoryArr,
      
    },
    yaxis:{
      labels:{
        style: {
          fontSize: '15px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 900,
          cssClass: 'apexcharts-xaxis-label',
        },
      }
    }
  }
}

var getOption1 = function(){
  // https://apexcharts.com/javascript-chart-demos/area-charts/basic/#
	return {
    colors: [],
    chart: {
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth', //smooth, straight
      width: 4,
    },
    grid: {
      show: true,
      // borderColor: '#90A4AE',
      xaxis: {
        lines: {
          show: true
        }
      },   
      yaxis: {
        lines: {
          show: true
        }
      },
    },
    xaxis: {
      // categories: [],
      tickAmount: 6,
      // tickPlacement: 'between',
      seriesName: '',
      show: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#3a3a3a'
      },
      labels: {
        style: {
          colors: '#3a3a3a',
          fontSize: '14px'
        },
        rotate: 0,
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM \'yy',
          day: 'dd MMM',
          hour: 'HH:mm'
        }
      },
      title: {
        // text: 'index',
        style: {
          color: '#3a3a3a',
          fontSize: '14px',
          fontWeight: 400,
        },
      },
    },
    yaxis: {
      seriesName: '',
      show: true,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#3a3a3a'
      },
      labels: {
        style: {
          colors: '#3a3a3a',
          fontSize: '14px'
        }
      },
      title: {
        // text: 'value',
        style: {
          color: '#3a3a3a',
          fontSize: '14px',
          fontWeight: 400,
        },
        rotate: -90,
        offsetX: 0,
      },
    },
    legend: {
      show: true,
      showForSingleSeries: false,
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '14px',
      fontWeight: 400,
      // customLegendItems: ['name'],
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: '#FFF',
        radius: 0,
      },
    },
    title: {
      // text: 'title',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: undefined,
        color: '#263238'
      },
    },
  }
}

var CHART_CONFIG = {
	OpterationOption: getOperationOption,
	TreatmentOption: getTreatmentOption,
	IncomePieOption: getIncomePieOption,
	IncomeDeptOption: getIncomeDeptOption,
	IncomeDoctorOption: getIncomeDoctorOption,
	Option1: getOption1,
}

export { CHART_CONFIG };